export default "__VITE_ASSET__4c85fc3a__"